
import { useParsedFieldProps } from "./useParsedFieldProps";
import { FILES } from "../SchemaTypes";
import FileInput from "../../Input/FileInput";
import Field from "../Field";

const FileField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = {
    type: FILES,
    parent,
    validations: { required, uploadsComplete: true }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <FileInput {...inputProps} />
    </Field>
  );
};

export default FileField;
